import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 統合登録フォーム（UNIFIED_REGISTRATION_SPEC 2.1）の共通データ源。
// 一度読んだ場所マスタはモジュール内で共有する（1ダイアログに複数の
// ピッカーが出ても取得は1回）。
let _locCache = {};
let _locPending = {};

export const registrationApi = {
  // `deptCode` を渡すと **その部署の場所 ＋ 共通** だけを返す（全社の棚を出さない）。
  locations: ({ force = false, deptCode = null } = {}) => {
    const key = deptCode || 'all';
    if (!force && _locCache[key]) return Promise.resolve(_locCache[key]);
    if (!force && _locPending[key]) return _locPending[key];
    _locPending[key] = axios.get(`${API}/locations`,
      { params: deptCode ? { dept_code: deptCode } : {} }).then((r) => {
      _locCache[key] = r.data || [];
      _locPending[key] = null;
      return _locCache[key];
    }).catch((e) => { _locPending[key] = null; throw e; });
    return _locPending[key];
  },
  invalidateLocations: () => { _locCache = {}; _locPending = {}; },
  createLocation: (b) => axios.post(`${API}/locations`, b).then((r) => r.data),
  // 品目マスター横断検索（部品受注入力と同じ口を使い回す。新しいAPIは作らない）
  masterSearch: (q) => axios.get(`${API}/shizai/parts-request/master-search`, { params: { q } })
    .then((r) => r.data),
};

export const unregisteredLocationLabel = (text) => (text ? `未登録の場所: ${text}` : '');
